import { FC } from 'react';
import {
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  List,
  ReferenceField,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить материал" />
  </TopToolbar>
);

export const MaterialList: FC = () => (
  <List title="Список материалов" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" />
      <ReferenceField
        source="feed_id"
        reference="feeds"
        label="Лента"
        emptyText="Нет ленты"
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="name" label="Название" />

      <DateField
        source="updated_at"
        label="Дата обновления"
        showTime={true}
        locales="ru-RU"
      />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
